module.exports = __webpack_public_path__ + "static/assets/4e451c331fc3e836537a771ba3419adc.jpg";